import {Component, OnInit, Input} from '@angular/core';
import {LocalDataSource} from 'ng2-smart-table';
import Swal, {SweetAlertIcon} from 'sweetalert2';
import {NbDialogService} from '@nebular/theme';
import {AuthorizationService} from '../../../../services/authorization.service';
import { StationService } from '../../../../services/stations.service';
import { UsersSgmSasisopaFormComponent } from '../users-sgm-sasisopa-form/users-sgm-sasisopa-form.component';

@Component({
  selector: 'ngx-users-sgm-sasisopa',
  templateUrl: './users-sgm-sasisopa.component.html',
})
export class UsersSgmSasisopaComponent implements OnInit {
  @Input() stationId: string;

  authorizationPerson = {
    name: '',
    role: 'NA',
    enabled: true,
    signature: '',
    type: 'sgm',
  };

  settings: any = {
    actions: {
      columnTitle: 'Acciones',
      position: 'right',
      add: false,
      edit: false,
      delete: false,
      custom: [
        {
          name: 'edit',
          title: '<img src="assets/images/icons/edit.png" width="25px">',
        },
        // {
        //   name: 'delete',
        //   title: '<img src="assets/images/icons/delete.png" width="25px">',
        // },
      ],
    },
    pager: {
      perPage: 10,
    },
    columns: {
      name: {
        title: 'Nombre',
        filter: true,
      },
    },
    noDataMessage: 'Sin registros',
  };
  loading = false;
  downloading = false;
  source: LocalDataSource;
  dataLoaded = false;

  constructor(
    private dialogService: NbDialogService,
    protected authorizationService: AuthorizationService,
    private stationService: StationService,
  ) {
  }

  ngOnInit() {
    this.init();
  }

  init() {
    this.getAuthorizationStation();
  }

  cleanStore() {
    this.authorizationPerson = {
      name: '',
      role: 'NA',
      enabled: true,
      signature: '',
      type: 'sgm',
    };
  }

  async getAuthorizationStation() {
    this.loading = true;
    const [err, response]: any = await this.authorizationService.indexSGM(this.stationId);
    this.loading = false;
    if (err) return this.alert('Oops, algo ocurrio', 'error', 'Intenta más tarde');
    this.source = new LocalDataSource(response.data.map(authorization => {
      return  { ...authorization, enabledTitle: authorization.enabled ? 'Activo' : 'Inactivo' };
    }));
  }

  openModal(isEdit = false) {
    this.dialogService.open(UsersSgmSasisopaFormComponent, {
      hasScroll: true,
      context: {
        authorizationPerson: this.authorizationPerson,
        stationId: this.stationId,
        isEdit,
      },
    }).onClose.subscribe((modified: boolean) => (
      modified
        ? this.getAuthorizationStation()
        : console.error('no modificaron nada'))
    );
  }

  async onCustom(event: any) {
    this.authorizationPerson = event.data;
    this.openModal(true);
  }

  async alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    await Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

}
